import { render, staticRenderFns } from "./OnboardingDepot.vue?vue&type=template&id=b7fb98b0&scoped=true&"
import script from "./OnboardingDepot.vue?vue&type=script&lang=js&"
export * from "./OnboardingDepot.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingDepot.vue?vue&type=style&index=0&id=b7fb98b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fb98b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
